import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito ser diseñador o copywriter?',
  a: 'No. Necesitás criterio para testear y medir. 100ads te entrega volumen y estructura.'
}, {
  q: '¿Esto me garantiza ventas?',
  a: 'No vendo magia. Te da lo que hoy te falta: volumen + ángulos + velocidad. Lo que hagas con eso (testear en serio) define el resultado.'
}, {
  q: '¿Ya probé Sora/Higgsfield/Canva… por qué esto sería distinto?',
  a: 'Porque esas herramientas te ponen en modo "artesano". 100ads te pone en modo testing: 100 piezas, ahora, para encontrar ganadores rápido.'
}, {
  q: '¿Tiene algún límite de creación?',
  a: 'No. Como conectás tu propia API de Google AI Studio (que es gratuita en su capa estándar), no tenés límites arbitrarios de la plataforma.'
}, {
  q: '¿Sirve para ebooks y cursos?',
  a: 'Sí. Está pensado para ofertas digitales donde el creativo tiene que vender promesa, claridad y transformación.'
}, {
  q: '¿Genera imágenes y videos?',
  a: 'Por ahora 100ads genera imágenes estáticas optimizadas para ads. Es lo que más impacto tiene en testing de volumen. Video viene más adelante.'
}, {
  q: '¿Hay algún plan gratuito para probar?',
  a: 'No. No ofrecemos plan free. Lo que sí ofrecemos es una garantía total de 72hs: si no te convence, te devolvemos el 100%. Además, tenemos cientos de resultados reales de usuarios que prueban que funciona.'
}, {
  q: '¿Es un pago único o suscripción?',
  a: 'Es una suscripción mensual. Pagás mes a mes y podés cancelar o pausar cuando quieras, sin permanencia ni penalidades. Si querés probar un mes y ver los resultados, podés hacerlo sin ningún compromiso.'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="glass-card rounded-xl overflow-hidden mb-4 transition-all duration-300 hover:bg-white/[0.05]" data-id="element-34">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 px-6 flex items-center justify-between text-left" data-id="element-35">
        <span className="font-bold text-lg md:text-xl pr-8 text-white" data-id="element-36">
          {q}
        </span>
        <span className={`flex-shrink-0 text-purple-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-37">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-38" /> : <PlusIcon className="w-6 h-6" data-id="element-39" />}
        </span>
      </button>
      <AnimatePresence data-id="element-40">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-41">
            <div className="px-6 pb-6 pt-0" data-id="element-42">
              <p className="text-gray-400 leading-relaxed text-base" data-id="element-43">{a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section id="faq" className="py-24 bg-[#050505]" data-id="element-44">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-45">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-46">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-2" data-id="element-47">
          {FAQS.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-48" />)}
        </div>
      </div>
    </section>;
}